import { render, staticRenderFns } from "./FullSummary.vue?vue&type=template&id=72d05b08&scoped=true"
import script from "./FullSummary.vue?vue&type=script&lang=js"
export * from "./FullSummary.vue?vue&type=script&lang=js"
import style0 from "./FullSummary.vue?vue&type=style&index=0&id=72d05b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d05b08",
  null
  
)

export default component.exports